import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../Store/Reducers";
import {ModalActions} from "../../../../Store/Modal/Slice";
import * as ModalTypes from "../../../../Store/Modal/Types";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faTimes} from "@fortawesome/free-solid-svg-icons";

const ConfirmModalComponent = () => {
  const dispatch = useDispatch();
  const { confirmModal } = useSelector((store: RootState ) => store.ModalReducer);

  const close = (confirmed: boolean) => {
    return dispatch(ModalActions.closeModal({modal: ModalTypes.CONFIRM_MODAL, result: confirmed}));
  };

  return(
    <Modal
      isOpen={confirmModal.open}
      toggle={() => close(false)}
      size="sm"
      centered
    >
      {/*<ModalHeader>{confirmModal.data?.title && 'Eliminar'}</ModalHeader>*/}
      <ModalBody>
        <p>{confirmModal.data?.question}</p>
      </ModalBody>
      <ModalFooter>
        <Button  onClick={() => close(false)} size="sm" outline color="danger">
          <FontAwesomeIcon icon={faTimes}/>&nbsp;
          Cancelar
        </Button>
        <Button onClick={() => close(true)} size="sm" outline color="success">
          <FontAwesomeIcon icon={faCheck}/>&nbsp;
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModalComponent;
